import React, {MutableRefObject, useEffect, useRef} from 'react';

import classNames from 'classnames';

import {isIEOrEdge} from '../helpers';

export interface IScrollProps {
    /**
     * Content.
     */
    children: React.ReactNode;
    /**
     * Additional class name.
     */
    className?: string;
    /**
     * Color.
     */
    color?: 'white';
    /**
     * Content reference attribute.
     */
    contentRef?: React.Ref<HTMLSpanElement>;
    /**
     * Element reference attribute.
     */
    elementRef?: (el: HTMLElement) => void;
    /**
     * Initial scroll position.
     */
    start?: 'bottom';
}

const Scroll = (props: IScrollProps): JSX.Element => {
    const element: MutableRefObject<null | HTMLElement> = useRef(null);

    const scrollToBottom = (): void => {
        if (element && element.current) {
            const scroll: number = element.current.scrollHeight - element.current.clientHeight;

            if (isIEOrEdge() === false) {
                element.current.scrollTo(0, scroll);
            } else {
                element.current.scrollTop = scroll;
            }
        }
    };

    useEffect(() => {

        if (props.start === 'bottom') {
            scrollToBottom();
        }

    }, [props.children]);

    const className: string = classNames(
        'scroll-fade',
        {
            [`scroll-fade--${props.color}`]: props.color,
        },
        props.className,
    );

    return (
        <span className={className}>
            <span
                className="scroll-fade__inner"
                ref={(el: HTMLElement | null): void => {
                    if (el && element.current !== el) {
                        element.current = el;

                        if (props.elementRef) {
                            props.elementRef(el);
                        }
                    }
                }}
            >
                <span ref={props.contentRef}>
                    {props.children}
                </span>
            </span>
        </span>
    );
};

export default Scroll;
